import React from 'react';
import { useTranslation } from 'react-i18next';

import FiltersActions from '../../../../actions/FiltersActions';
import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

import FilterCheckboxWithLabel from './components/FilterCheckboxWithLabel.react';

function FreeCancellationFilter({ filter, profile }) {
	const { t } = useTranslation();

	const handleCheckboxChange = (isInputChecked) => {
		FiltersActions.filterByFreeCancellation(isInputChecked);

		const filter_value = t(isInputChecked ? 'FreeCancellationOnly' : 'ShowAll');
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.FREE_CANCELLATION,
			filter_value,
		);
	};

	return (
		<div className="filter">
			<label className="filter-title" htmlFor="free-cancellation-filter">
				{t('FreeCancellationFilterTitle')}
			</label>
			<div name="free-cancellation-filter" className="check-list" aria-label={t('FreeCancellationFilterTitle')}>
				<div className="checkbox-container">
					<FilterCheckboxWithLabel
						checked={filter}
						label={t('FreeCancellationOnly')}
						onChange={(e, c) => handleCheckboxChange(c)}
					/>
				</div>
			</div>
		</div>
	);
}

export default FreeCancellationFilter;
